import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import t from "../../../../core/Handles.js";
import { addFrameTask as i } from "../../../../core/scheduling.js";
import { init as e } from "../../../../core/watchUtils.js";
import { translateBy as a, scaleAndRotateBy as s } from "../../viewpointUtils.js";
import { InputHandler as n } from "../../../input/InputHandler.js";
import { resetTransformation as r, extractTransformation as o, isZeroTransformation as h } from "../../../navigation/gamepadAndKeyboardUtils.js";

var l = /*#__PURE__*/function (_n) {
  _inherits(l, _n);

  var _super = _createSuper(l);

  function l(i) {
    var _this;

    _classCallCheck(this, l);

    _this = _super.call(this, !0), _this.view = i, _this.frameTask = null, _this.watchHandles = new t(), _this.currentDevice = null, _this.transformation = {
      translation: [0, 0, 0],
      heading: 0,
      tilt: 0,
      zoom: 0
    }, _this.handle = _this.registerIncoming("gamepad", function (t) {
      return _this.handleEvent(t);
    }), _this.handle.pause();
    return _this;
  }

  _createClass(l, [{
    key: "onInstall",
    value: function onInstall(t) {
      var _this2 = this;

      _get(_getPrototypeOf(l.prototype), "onInstall", this).call(this, t), this.watchHandles.add([e(this.view.navigation.gamepad, "enabled", function (t) {
        t ? (_this2.handle.resume(), _this2.frameTask || (_this2.frameTask = i({
          update: function update(t) {
            return _this2.frameUpdate(t.deltaTime);
          }
        }))) : (_this2.handle.pause(), _this2.frameTask && (_this2.frameTask.remove(), _this2.frameTask = null));
      })]);
    }
  }, {
    key: "onUninstall",
    value: function onUninstall() {
      this.watchHandles.removeAll(), this.frameTask && (this.frameTask.remove(), this.frameTask = null), _get(_getPrototypeOf(l.prototype), "onUninstall", this).call(this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(t) {
      var i = this.view.navigation.gamepad.device;
      i && t.data.device !== i || this.currentDevice && this.currentDevice !== t.data.device || ("end" === t.data.action ? (this.currentDevice = null, r(this.transformation)) : (this.currentDevice = t.data.device, o(t.data, this.view.navigation.gamepad, this.transformation)));
    }
  }, {
    key: "frameUpdate",
    value: function frameUpdate(t) {
      var i = this.transformation;
      if (h(i)) return;
      var e = this.view.viewpoint.clone(),
          n = this.view.navigation.gamepad.velocityFactor,
          r = m * n * t;
      a(e, e, [i.translation[0] * r, -i.translation[1] * r]);

      var o = 1 + i.translation[2] * c * t,
          _l = this.view.constraints.rotationEnabled ? -i.heading * d * t : 0,
          v = this.view.size,
          p = [v[0] / 2, v[1]];

      s(e, e, o, _l, p, v);
      var f = this.view.constraints.constrain(e, this.view.viewpoint);
      this.view.viewpoint = f;
    }
  }]);

  return l;
}(n);

var d = .06,
    m = .7,
    c = 6e-4;
export { l as GamepadNavigation };